/* eslint-disable */
import React, { useContext, useMemo, useState } from "react";
import {
  Alert,
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import {
  Grid,
  Paper,
  Button,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { useHistory, Link } from "react-router-dom";
import { PAGES } from "constants/pages";
import { useValidPassword } from "../../hooks/useValidPassword";
import { useValidEmail } from "../../hooks/useValidEmail";
import {
  alertStyle,
  backgroundStyle,
  btnStyle,
  forgotPasswordStyle,
  inputStyle,
  labelStyle,
  paperStyle,
} from "./styles";
import { AuthContext } from "../../contexts/authContext";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { PasswordType } from "interfaces/IPassType";
import { Header } from "components/Header/Header";

const SignIn: React.FC<any> = () => {
  const { email, setEmail, emailIsValid } = useValidEmail("");
  const { password, setPassword, passwordIsValid } = useValidPassword("");
  const [showPassword, setshowPassword] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const [genericErrorMessage, setGenericErrorMessage] = useState("");

  const theme = useMemo(() => {
    return authContext.globalConfig?.theme as unknown as undefined;
  }, [authContext]);

  const handleClickShowPassword = () => {
    setshowPassword(!showPassword);
  };

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      const isDisabled = emailIsValid != "" || password == "" || isLoading;
      if (!isDisabled) {
        onLoginPressed(e);
      }
    }
  };

  const signInCallback = (type: "mfa" | "password") => {
    if (email && password) {
      if (type === "mfa") {
        history.push(`/VerifyTwoFA/${email}`);
      } else {
        try {
          // Credentials must never be placed in the URL: they would persist in
          // browser history and leak via the Referer header. Pass them in
          // router state instead.
          history.push("/CheckPassword", {
            email,
            type: PasswordType.SIGNUP,
            oldPassword: password,
          });
        } catch (err: any) {
          setGenericErrorMessage(
            `${
              err.message?.includes("Lambda")
                ? "Please try again later."
                : err.message
            }`
          );
        }
      }
    }
  };

  const onLoginPressed = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    setGenericErrorMessage("");
    if (email && password)
      try {
        await authContext.signInWithEmail(
          email.toLowerCase(),
          password,
          signInCallback
        );
        if (!authContext.mfaRequired) {
          authContext.handleRedirection();
        }
      } catch (error: any) {
        console.log(error.code);
        setLoading(false);
        if (error.code === "NEW_PASSWORD_REQUIRED") {
          try {
            // history.push("/CheckPassword", {
            //   email,
            //   type: PasswordType.SIGNUP,
            //   oldPassword: password,
            // });
          } catch (err: any) {
            setGenericErrorMessage(
              `${
                err.message?.includes("Lambda")
                  ? "Please try again later."
                  : err.message
              }`
            );
          }
        } else {
          let errorMessage = error.message;

          if (
            error.message === "User is disabled." &&
            error.code === "NotAuthorizedException"
          ) {
            errorMessage =
              "Your user account is disabled. Please contact Allheartz admin if you want to reactivate your account";
          }
          setGenericErrorMessage(
            `${
              errorMessage?.includes("Lambda")
                ? "Please try again later."
                : errorMessage
            }`
          );
        }
      }
  };

  return (
    <>
      <Header showSettings={false} />
      <div style={backgroundStyle}>
        <Grid container justifyContent="center" alignContent="center">
          <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
            <Paper elevation={0} style={paperStyle}>
              <div style={{ margin: "0px auto" }}>
                {genericErrorMessage != "" ? (
                  <Alert style={alertStyle} variant="outlined" severity="error">
                    Error: {genericErrorMessage}
                  </Alert>
                ) : null}
                <FormControl variant="outlined" fullWidth>
                  <OutlinedInput
                    error={genericErrorMessage != ""}
                    size="small"
                    id="email"
                    style={inputStyle}
                    type="text"
                    value={email}
                    onChange={(e: any) =>
                      setEmail(e.target.value.replace(/ /g, ""))
                    }
                    onKeyDown={handleKeyDown}
                    placeholder="Email"
                  />
                </FormControl>
                <FormControl variant="outlined" fullWidth>
                  <OutlinedInput
                    error={genericErrorMessage != ""}
                    size="small"
                    id="password"
                    style={inputStyle}
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e: any) =>
                      setPassword(e.target.value.replace(/ /g, ""))
                    }
                    onKeyDown={handleKeyDown}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    placeholder="Password"
                  />
                </FormControl>
                <div style={labelStyle}>
                  <Typography>
                    <Link to="/ForgotPasswordEmail" style={forgotPasswordStyle}>
                      Forgot password
                    </Link>
                  </Typography>
                </div>
              </div>
            </Paper>
            <Button
              type="submit"
              color="primary"
              id="submit"
              className="authbutton"
              variant="contained"
              fullWidth
              style={btnStyle}
              disabled={emailIsValid != "" || password == "" || isLoading}
              onClick={(e) => {
                onLoginPressed(e);
              }}
            >
              {isLoading ? <CircularProgress size={20} /> : "Submit"}
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default SignIn;
